// Zugänge freischalten: Aufbereitung der Antwort von
// GET /automation/zugangsanfragen. Aus ZugangsanfragenPage.jsx herausgelöst
// (23.09.2026), damit Desktop und mobile Oberfläche dieselbe Rechnung nutzen.

export function formatiereZeitpunkt(wert) {
  if (!wert) return '';
  const datum = new Date(wert);
  if (Number.isNaN(datum.getTime())) return '';
  return datum.toLocaleString('de-DE', {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
}

/** Freigegebene Konten nach Name oder E-Mail filtern (wie am Desktop). */
export function filtereKonten(konten, suche) {
  const suchbegriff = String(suche || '').trim().toLowerCase();
  return (konten || []).filter((k) => (
    !suchbegriff
    || String(k.email).toLowerCase().includes(suchbegriff)
    || String(k.name).toLowerCase().includes(suchbegriff)
  ));
}

/** Alle Listen der Antwort mit sicheren Vorgaben; freigegeben schon gefiltert. */
export function bereiteZugaengeAuf(daten, suche = '') {
  const liste = (wert) => (Array.isArray(wert) ? wert : []);
  return {
    werkzeuge: liste(daten?.werkzeuge),
    fremdverwaltet: liste(daten?.fremdverwaltet),
    wartend: liste(daten?.wartend),
    abgelehnt: liste(daten?.abgelehnt),
    freigegeben: filtereKonten(liste(daten?.freigegeben), suche),
  };
}

export function kontoTitel(konto) {
  return konto?.name || konto?.email || '';
}

/** "mail · angelegt 23.09.2026, 08:12" bzw. "… abgelehnt … von …". */
export function kontoUnterzeile(konto, art = 'angelegt') {
  const vorn = konto?.name ? `${konto.email} · ` : '';
  if (art === 'abgelehnt') {
    const von = konto?.abgelehntVon ? ` von ${konto.abgelehntVon}` : '';
    return `${vorn}abgelehnt ${formatiereZeitpunkt(konto?.abgelehntAm)}${von}`.trim();
  }
  return `${vorn}angelegt ${formatiereZeitpunkt(konto?.angelegtAm)}`.trim();
}

/** Kurzfassung unter dem Namen: "Admin · NAP-Tool · Kundenportal" oder "Nur Grundzugang". */
export function kontoKurzinfo(konto, werkzeuge = []) {
  const teile = [
    konto?.istAdmin ? 'Admin' : '',
    ...werkzeuge.map((w) => (konto?.werkzeuge?.[w.id] === true ? w.titel : '')),
  ].filter(Boolean);
  return teile.length ? teile.join(' · ') : 'Nur Grundzugang';
}
